/**
 * Responsive Image Handler for Hero Slider
 * Handles switching between desktop and mobile images based on screen size
 */

class ResponsiveImages {
    constructor() {
        this.breakpoint = 768; // breakpoint
        this.init();
    }

    init() {
        this.handleResize();
        window.addEventListener('resize', this.debounce(this.handleResize.bind(this), 250));
    }

    handleResize() {
        const isMobile = window.innerWidth < this.breakpoint;
        const slides = document.querySelectorAll('.swiper-slide[data-mobile-image]');
        
        slides.forEach((slide) => {
            const mobileOverlay = slide.querySelector('.hero__slide-mobile');
            if (mobileOverlay) {
                if (isMobile) {
                    // Show mobile image and hide desktop background
                    mobileOverlay.style.opacity = '1';
                    mobileOverlay.style.pointerEvents = 'auto';
                    mobileOverlay.style.position = 'absolute';
                    mobileOverlay.style.top = '0';
                    mobileOverlay.style.left = '0';
                    mobileOverlay.style.width = '100%';
                    mobileOverlay.style.height = '100%';
                    mobileOverlay.style.zIndex = '1';
                    mobileOverlay.style.backgroundSize = 'cover';
                    mobileOverlay.style.backgroundPosition = 'center';
                    slide.style.backgroundImage = 'none'; // Hide desktop background
                } else {
                    // Hide mobile image and show desktop background
                    mobileOverlay.style.opacity = '0';
                    mobileOverlay.style.pointerEvents = 'none';
                    // Reset mobile overlay positioning to let CSS handle it
                    mobileOverlay.style.removeProperty('position');
                    mobileOverlay.style.removeProperty('top');
                    mobileOverlay.style.removeProperty('left');
                    mobileOverlay.style.removeProperty('width');
                    mobileOverlay.style.removeProperty('height');
                    mobileOverlay.style.removeProperty('z-index');
                    mobileOverlay.style.removeProperty('background-size');
                    mobileOverlay.style.removeProperty('background-position');
                    // Restore desktop background from data attribute
                    const desktopImage = slide.getAttribute('data-desktop-image');
                    if (desktopImage) {
                        slide.style.backgroundImage = desktopImage;
                    }
                }
            }
        });
    }

    debounce(func, wait) {
        let timeout;
        return function executedFunction(...args) {
            const later = () => {
                clearTimeout(timeout);
                func(...args);
            };
            clearTimeout(timeout);
            timeout = setTimeout(later, wait);
        };
    }
}

export default ResponsiveImages; 